import React from 'react';

function TeamsModal({ show, onClose, teams }) {
  if (!show) return null;

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center p-4 sm:p-6"
      style={{ backgroundColor: "rgba(0, 0, 0, 0.95)" }}
      onClick={onClose}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        className="relative w-full max-w-7xl h-[85vh] rounded-3xl border backdrop-blur-2xl overflow-hidden flex flex-col"
        style={{
          backgroundColor: "rgba(17, 24, 39, 0.95)",
          borderColor: "rgba(34, 197, 94, 0.4)",
          boxShadow: "0 25px 80px rgba(34, 197, 94, 0.25), inset 0 1px 0 rgba(255,255,255,0.1)",
        }}
      >
        {/* Animated Background */}
        <div className="absolute inset-0 pointer-events-none overflow-hidden">
          <div
            className="absolute rounded-full opacity-20 blur-3xl animate-pulse"
            style={{
              width: "500px",
              height: "500px",
              background: "radial-gradient(circle, #22c55e 0%, transparent 70%)",
              top: "-200px",
              right: "-100px",
              animationDuration: "4s",
            }}
          />
          <div
            className="absolute rounded-full opacity-20 blur-3xl animate-pulse"
            style={{
              width: "400px",
              height: "400px",
              background: "radial-gradient(circle, #22c55e 0%, transparent 70%)",
              bottom: "-150px",
              left: "-100px",
              animationDuration: "5s",
              animationDelay: "1s",
            }}
          />
        </div>

        {/* Header */}
        <div
          className="relative z-10 flex-shrink-0 flex items-center justify-between px-4 sm:px-6 py-4 border-b backdrop-blur-xl"
          style={{
            borderColor: "rgba(34, 197, 94, 0.3)",
            backgroundColor: "rgba(17, 24, 39, 0.8)",
          }}
        >
          <div className="flex items-center gap-3">
            <div
              className="w-10 h-10 sm:w-11 sm:h-11 rounded-xl flex items-center justify-center relative"
              style={{
                backgroundColor: "#22c55e",
                boxShadow: "0 0 30px rgba(34, 197, 94, 0.6)",
              }}
            >
              <svg
                className="w-5 h-5 sm:w-6 sm:h-6 text-white"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2.5}
                  d="M17 20h5v-2a4 4 0 00-5-3.87M9 20H4v-2a4 4 0 015-3.87m6-6a4 4 0 11-8 0 4 4 0 018 0z"
                />
              </svg>
              <div
                className="absolute inset-0 rounded-xl animate-ping opacity-75"
                style={{ backgroundColor: "#22c55e" }}
              />
            </div>
            <div>
              <h2 className="text-lg sm:text-xl font-black text-white">تیم‌های مسابقه</h2>
              <p className="text-xs text-green-400 font-semibold">{teams.length} تیم فعال</p>
            </div>
          </div>

          <button
            onClick={onClose}
            className="w-9 h-9 sm:w-10 sm:h-10 rounded-xl flex items-center justify-center transition-all duration-200 hover:scale-110 hover:rotate-90 group"
            style={{
              backgroundColor: "rgba(239, 68, 68, 0.15)",
              border: "1px solid rgba(239, 68, 68, 0.3)",
            }}
          >
            <svg
              className="w-5 h-5 text-red-400 group-hover:text-red-300"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2.5}
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </button>
        </div>

        {/* Content */}
        <div className="relative z-10 flex-1 overflow-hidden">
          {!teams || teams.length === 0 ? (
            <div className="flex flex-col items-center justify-center h-full px-4">
              <div
                className="w-20 h-20 rounded-2xl flex items-center justify-center mb-4 animate-bounce"
                style={{
                  backgroundColor: "rgba(34, 197, 94, 0.15)",
                  border: "2px dashed rgba(34, 197, 94, 0.4)",
                }}
              >
                <svg
                  className="w-10 h-10 text-green-400"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M17 20h5v-2a4 4 0 00-5-3.87M9 20H4v-2a4 4 0 015-3.87m6-6a4 4 0 11-8 0 4 4 0 018 0z"
                  />
                </svg>
              </div>
              <p className="text-white text-lg font-bold">هیچ تیمی یافت نشد</p>
              <p className="text-gray-500 text-sm mt-1">به‌محض اضافه‌شدن نمایش داده می‌شود</p>
            </div>
          ) : (
            <div className="h-full overflow-y-auto px-6 py-6">
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6 mx-auto" style={{ maxWidth: "100%" }}>
                {teams.map((team, index) => {
                  const borderColor = team.color || "#22c55e";
                  const members = Array.isArray(team.members) ? team.members : [];

                  return (
                    <div
                      key={team.id}
                      className="rounded-2xl overflow-hidden transition-all duration-300 hover:scale-[1.02] group relative flex flex-col"
                      style={{
                        background: "rgba(17, 24, 39, 0.6)",
                        backdropFilter: "blur(10px)",
                        border: `1px solid ${borderColor}40`,
                        boxShadow: `0 4px 20px ${borderColor}20`,
                        animation: `fadeInUp 0.5s ease-out ${index * 0.05}s backwards`,
                      }}
                    >
                      <div className="h-1 w-full" style={{ background: `linear-gradient(90deg, ${borderColor}, transparent)` }} />

                      <div className="p-4 flex flex-col h-full">
                        <div className="flex items-start gap-3 mb-4 flex-shrink-0">
                          <div
                            className="w-16 h-16 rounded-xl overflow-hidden flex-shrink-0 group-hover:scale-110 transition-transform duration-300"
                            style={{
                              border: `2px solid ${borderColor}60`,
                              boxShadow: `0 0 20px ${borderColor}30`,
                            }}
                          >
                            {team.logo_path ? (
                              <img
                                src={`/${team.logo_path}`}
                                alt={team.name}
                                className="w-full h-full object-cover"
                                onError={(e) => (e.currentTarget.style.display = "none")}
                              />
                            ) : (
                              <div
                                className="w-full h-full flex items-center justify-center text-2xl font-black"
                                style={{
                                  background: `linear-gradient(135deg, ${borderColor}, ${borderColor}CC)`,
                                  color: "#000",
                                }}
                              >
                                {team.name?.[0] || "ت"}
                              </div>
                            )}
                          </div>

                          <div className="flex-1 min-w-0">
                            <div className="flex items-center gap-2 mb-1">
                              <span
                                className="w-7 h-7 rounded-md flex items-center justify-center text-sm font-black flex-shrink-0"
                                style={{
                                  background: borderColor,
                                  color: "#000",
                                }}
                              >
                                {team.id}
                              </span>
                              <h3 className="text-sm font-bold text-white truncate">{team.name || "بدون‌نام"}</h3>
                            </div>

                            <span
                              className="inline-block text-xs px-2.5 py-1 rounded-full font-bold"
                              style={{
                                backgroundColor:
                                  team.status === "active" ? "rgba(34,197,94,0.2)" : "rgba(239,68,68,0.2)",
                                color: team.status === "active" ? "#22c55e" : "#ef4444",
                              }}
                            >
                              {team.status === "active" ? "فعال" : "غیرفعال"}
                            </span>
                          </div>
                        </div>

                        <div className="grid grid-cols-2 gap-3 mb-4 flex-shrink-0">
                          <div
                            className="rounded-lg p-2.5 text-center"
                            style={{
                              background: `${borderColor}15`,
                              border: `1px solid ${borderColor}30`,
                            }}
                          >
                            <div className="text-xs text-gray-400 mb-1">امتیاز</div>
                            <div className="text-xl font-black" style={{ color: borderColor }}>
                              {team.points ?? 0}
                            </div>
                          </div>

                          <div className="rounded-lg p-2.5 text-center bg-white/5">
                            <div className="text-xs text-gray-400 mb-1">اعضا</div>
                            <div className="text-xl font-black text-white">{members.length}</div>
                          </div>
                        </div>

                        <div className="space-y-2 flex-1 overflow-y-auto min-h-0" style={{ scrollbarWidth: "thin" }}>
                          {members.length === 0 ? (
                            <div className="text-center py-6">
                              <p className="text-gray-500 text-xs">بدون عضو</p>
                            </div>
                          ) : (
                            members.map((m) => {
                              const username = m?.user?.username || m?.user?.email || "—";
                              const firstLetter = (username?.[0] || "U").toUpperCase();
                              const isCaptain = (m?.role || "").toLowerCase() === "captain";

                              return (
                                <div
                                  key={m.id}
                                  className="rounded-lg p-2 flex items-center gap-2 transition-all duration-200"
                                  style={{
                                    backgroundColor: isCaptain
                                      ? "rgba(253,224,71,0.1)"
                                      : "rgba(255,255,255,0.03)",
                                    border: `1px solid ${
                                      isCaptain ? "rgba(253,224,71,0.25)" : "rgba(255,255,255,0.05)"
                                    }`,
                                  }}
                                >
                                  <div
                                    className="w-8 h-8 rounded-lg flex items-center justify-center font-bold flex-shrink-0 text-xs"
                                    style={{
                                      background: isCaptain
                                        ? "linear-gradient(135deg, #fde047, #facc15)"
                                        : "rgba(255,255,255,0.1)",
                                      color: isCaptain ? "#000" : "#fff",
                                    }}
                                  >
                                    {firstLetter}
                                  </div>

                                  <div className="flex-1 min-w-0">
                                    <div className="flex items-center gap-1">
                                      <span className="text-white font-semibold text-xs truncate">
                                        {username}
                                      </span>
                                      {isCaptain && <span className="text-xs text-yellow-400">★</span>}
                                    </div>
                                    <div
                                      className="text-[10px] font-bold"
                                      style={{
                                        color: m?.is_active ? "#22c55e" : "#6b7280",
                                      }}
                                    >
                                      {m?.is_active ? "● آنلاین" : "● آفلاین"}
                                    </div>
                                  </div>
                                </div>
                              );
                            })
                          )}
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          )}
        </div>
      </div>

      <style>{`
        @keyframes fadeInUp {
          from {
            opacity: 0;
            transform: translateY(20px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        div::-webkit-scrollbar {
          width: 6px;
          height: 6px;
        }
        div::-webkit-scrollbar-track {
          background: rgba(255, 255, 255, 0.05);
          border-radius: 10px;
        }
        div::-webkit-scrollbar-thumb {
          background: rgba(34, 197, 94, 0.4);
          border-radius: 10px;
        }
        div::-webkit-scrollbar-thumb:hover {
          background: rgba(34, 197, 94, 0.6);
        }
      `}</style>
    </div>
  );
}

export default TeamsModal;